import {NgModule} from '@angular/core';
import {A11yModule} from '@angular/cdk/a11y';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';

import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatFormFieldModule} from '@angular/material/form-field'; 
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon'; 
import {MatDatepickerModule} from '@angular/material/datepicker'; 
import {MatAutocompleteModule} from '@angular/material/autocomplete'; 
import {MatSelectModule} from '@angular/material/select'; 
import {MatNativeDateModule} from '@angular/material/core';
import {MatCheckboxModule} from '@angular/material/checkbox'; 
import {MatDividerModule} from '@angular/material/divider'; 
import {MatListModule} from '@angular/material/list'; 
import {MatTableModule} from '@angular/material/table'; 
import {MatSnackBarModule} from '@angular/material/snack-bar'; 
import {MatDialogModule} from '@angular/material/dialog'; 
import {MatBadgeModule} from '@angular/material/badge'; 
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTableExporterModule } from 'mat-table-exporter';
import {MatGridListModule} from '@angular/material/grid-list'; 
import {MatRadioModule} from '@angular/material/radio'; 
import {MatExpansionModule} from '@angular/material/expansion'; 
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule} from '@angular/material/tabs';

import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatStepperModule} from '@angular/material/stepper';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSortModule} from '@angular/material/sort';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {OverlayModule} from '@angular/cdk/overlay';

const MaterialComponents = [
  A11yModule,
  CdkAccordionModule,
  ClipboardModule,
  CdkStepperModule,
  CdkTableModule,
  CdkTreeModule,
  DragDropModule,
  PortalModule,
  ScrollingModule,

  MatButtonModule,
  MatToolbarModule,
  MatFormFieldModule,
  MatCardModule,
  MatInputModule,
  MatSidenavModule,
  MatIconModule,
  MatDatepickerModule,
  MatAutocompleteModule,
  MatSelectModule,
  MatNativeDateModule,
  MatCheckboxModule,
  MatDividerModule,
  MatListModule,
  MatTableModule,
  MatSnackBarModule,
  MatDialogModule,
  MatBadgeModule,  
  MatPaginatorModule,
  MatTableExporterModule,
  MatGridListModule,
  MatRadioModule,
  MatExpansionModule,
  MatChipsModule,
  MatTabsModule,

  MatBottomSheetModule,
  MatButtonToggleModule,
  MatStepperModule,
  MatMenuModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSortModule,
  MatTooltipModule,
  MatTreeModule,
  OverlayModule, 
]

@NgModule({
imports: [MaterialComponents],
exports: [MaterialComponents]
})

export class MaterialModule { }
